export default __webpack_public_path__ + "static/media/mysql.0da7cd18.png";